import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '.abyss-checkbox-label': {
    fontWeight: 'bold !important',
  },
  '.abyss-checkbox-root': {
    marginTop: 'var(--abyss-space-md)',
  },
  '.abyss-modal-footer': {
    '.abyss-layout-group': {
      paddingTop: 'var(--abyss-space-sm)',
    },
  },
  '.abyss-modal-section-root': {
    position: 'relative',
  },
});
